import { APP_CONFIG } from '../../data/constants.jsx'

/**
 * Single source of truth for the brand mark.
 * variant: 'mark'           square icon
 *          'lockup'         icon + wordmark, opaque white panel (social cards)
 *          'lockupOnLight'  transparent panel, for light backgrounds
 *          'lockupInverted' all-white, for dark backgrounds
 */
const Logo = ({ variant = 'mark', className = 'w-10 h-10 rounded-lg shadow-soft', ...props }) => (
  <img
    src={APP_CONFIG.logo[variant]}
    alt={APP_CONFIG.name}
    className={className}
    {...props}
  />
)

export default Logo
